module.exports = __webpack_public_path__ + "static/media/stripe-connect-logo.ddbd14e1.png";